import UIObject from '../common/dynamic-form/UIObject'
import { InputField, INPUT_TYPE } from '../common/dynamic-form/InputField'
import React from 'react';

export interface IBaseGameObject {
    name: string,
    description?: string,
    gameType: string,
    icon?: any,
    hint?: string,
    index: number,
    isPublic?:boolean,
    maxQuestion?:number 
}

export const GAME_TYPE = Object.freeze({
    DEMSO : {key:'demso', label: "Đếm số"},
    TRACNGHIEM: {key:'tracnghiem', label: "Trắc nghiệm"},
    NHATBI: {key:'nhatbi', label: "Nhặt bi"},
    DRAGDROP: {key:'dragdrop', label: "Nối các đáp án"},
    DRAW: {key:'draw', label: "Viết và vẽ"},
    DAPCHUOT: {key:'dapchuot', label: "Đập chuột chũi"},
    PICK: {key:'pick', label: "Chọn hình ảnh đúng"},
    MAPPING: {key:'mapping', label: "Kéo thả hình ảnh và vị trí đúng"},
    CHUOI_TRACNGHIEM: {key:'chuoitracnghiem', label: "Chuỗi trắc nghiệm liên tiếp"},
    TWIN: {key:'twin', label: "Chọn 2 hình giống nhau"},
    FISHSING: {key:'fishing', label: "Câu cá"},
    PAINTING: {key:'painting', label: "Tô màu"},
})

// export const GAME_TYPE = [
//     {key:'demso', label: "Đếm số"},
//     {key:'tracnghiem', label: "Trắc nghiệm"},
//     {key:'nhatbi', label: "Nhặt bi"},
//     {key:'dragdrop', label: "Nối các đáp án"},
//     // {key:'draw', label: "Viết và vẽ"},
//     {key:'dapchuot', label: "Đập chuột chũi"},
//     {key:'pick', label: "Chọn hình ảnh đúng"},
//     {key:'mapping', label: "Kéo thả hình ảnh và vị trí đúng"},
//     {key:'chuoitracnghiem', label: "Chuỗi trắc nghiệm liên tiếp"},
//     {key:'twin', label: "Chọn 2 hình giống nhau"},
//     // {key:'fishing', label: "Câu cá"},
//     // {key:'painting', label: "Tô màu"},
// ]

export default class BaseGameObject extends UIObject {

    constructor(data: IBaseGameObject) {
        super(data);

        this.updateFieldProperties(new InputField({
            key: "name",
            label: "Tên game ",
            value: data.name,
            required: true,
            extra: {
                props: { placeholder: "Nhập tên của game này..." },
                require_message: "Tên game là bắt buộc",
                rules: [
                    {
                        type: "string",
                        required: true,
                        whitespace: true,
                        message: "Không được để trống tên game"
                    }
                ]
            }
        }), 0)
        
        const gameType = new InputField({ key: "gameType", label: "Thể loại game", value: data.gameType, required: true, extra: { props: { placeholder: "Hãy chọn thể loại game", require_message: "Thể lại game là bắt buộc" } } });
        let types: any[]=[];
        Object.keys(GAME_TYPE).forEach(type => { types.push({ value: GAME_TYPE[type as keyof typeof GAME_TYPE].key, label: <span>{GAME_TYPE[type as keyof typeof GAME_TYPE].label}</span> })})
        // Object.keys(GAME_TYPE).forEach(type => {console.log("GAME_TYPE: ",  GAME_TYPE[type as keyof typeof GAME_TYPE])});
        gameType.convertToSelect(types);
        this.updateFieldProperties(gameType, 1)

        this.updateFieldProperties(new InputField({ key: "description", label: "Mô tả", value: data.description, extra: { props: { placeholder: "Mô tả ngắn để giải thích về game này.." } } }), 2)
        this.updateFieldProperties(new InputField({ key: "hint", label: "Gợi ý", value: data.hint, extra: { props: { placeholder: "Một số gợi ý để hướng dẫn bé chơi game này" }} }), 3)
        this.updateFieldProperties(new InputField({ key: "index", label: "Thứ tự", value: 1, extra: { props: { min:0, max:20 } } }), 4)
        this.updateFieldProperties(new InputField({ key: "maxQuestion", label: "Số câu hỏi", value: 1, extra: { props: { min:0, max:10 } } }), 5)
        this.updateFieldProperties(new InputField({ key: "isPublic", label: "Công bố chính thức", value: data.isPublic?data.isPublic:false }), 6)
        this.updateFieldProperties(new InputField({ key: "icon", label: "Game Icon", value:data.icon?data.icon:"", inputType: INPUT_TYPE.LOGO, extra:{props:{value:data.icon}} }), 7)

        this.mapData();
    }
}
